import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetMediaVideoResponse,
  PostMediaVideoResponse,
  GetMediaVideoByIdResponse,
  PutMediaVideoResponse,
  PutMediaLiveVideoResponse,
} from '../response/video';

export class VideoService {
  static getVideos(params?: QueryParams) {
    return apiClient.get<GetMediaVideoResponse>(buildApiUrl('/api/v1/media/video'), params);
  }

  static postVideo(data: any) {
    return apiClient.createWithFile<PostMediaVideoResponse>(buildApiUrl('/api/v1/media/video'), data);
  }

  static getVideoById(id: string) {
    return apiClient.get<GetMediaVideoByIdResponse>(buildApiUrl('/api/v1/media/video/:id', { id }), undefined);
  }

  static putVideo(id: string, data: any) {
    return apiClient.update<PutMediaVideoResponse>(buildApiUrl('/api/v1/media/video/:id', { id }), data);
  }

  static putLiveVideo(data: any) {
    return apiClient.updateWithFile<PutMediaLiveVideoResponse>(buildApiUrl('/api/v1/media/live-video'), data);
  }

  static deleteVideo(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/media/video/:id', { id }), undefined);
  }

  static deleteLiveVideo() {
    return apiClient.delete<void>(buildApiUrl('/api/v1/media/live-video'), undefined);
  }
}
